import { computed, ref } from 'vue';

import filled from '../javascripts/filled';
import { cloneName, CLONE_REGEXP } from '../javascripts/name';
import { VISIBLE_OPTIONS_FALSE } from '../javascripts/options';

export default function classer(props, planter) {
  const {
    leaves,
    tree,
    properties,
    errors,
  } = planter;

  let first = Number.MAX_SAFE_INTEGER;

  const _inlineVisible = props.settings._inline?.visible;
  const inlineEnabled = computed(() => !!Object.keys(props.inlines).length);
  const inlineVisible = ref(inlineEnabled.value && filled(_inlineVisible) && ![false, 'false'].includes(_inlineVisible));

  function inlineToggle() {
    inlineVisible.value = !inlineVisible.value;
  }

  const classes = ref({
    branches: computed(() => Object
      .keys(tree.value)
      .reduce((reduced, name, index) => {
        const hidden = !tree.value[name].leaves.some((i) => errors.value[i]) && (
          !tree.value[name].leaves.some((i) => !properties.value[i].hidden)
          || tree.value[name].settings.visibility === VISIBLE_OPTIONS_FALSE
        );
        const top = first >= index;
        const clonable = CLONE_REGEXP.test(name);

        reduced[name] = {
          'credere-form-branch': true,

          'variant--top': top,
          'variant--clonable': clonable,
          'variant--clone': clonable && !top,

          'state--hidden': hidden,
        };

        if (!hidden) {
          first = index;
        }

        return reduced;
      }, {})),

    leaves: computed(() => Object
      .keys(leaves.value)
      .reduce((reduced, name) => {
        const size = props.sizes[name] || props.sizes[cloneName(name)];

        reduced[name] = {
          'credere-form-leaf': true,

          [`size--${size}`]: !!size,

          'state--hidden': properties.value[name].hidden || (inlineEnabled.value && !inlineVisible.value && !props.inlines[name]),
          'state--destroyed': properties.value[name].destroyed,

          'variant--destroyer': name === properties.value[name].destroyer,
          'variant--inline': inlineEnabled.value && props.inlines[name],
        };

        return reduced;
      }, {})),
  });

  return {
    classes,

    inlineEnabled,
    inlineVisible,
    inlineToggle,
  };
}
